import { createFileRoute, Outlet, } from '@tanstack/react-router';
import { api, } from '../../../api/Api.js';
import { configStore, } from '../../../common/config/ConfigStore.js';
/*
 * this route is used to decouple the fetching data
 * from slug creation/comparison to avoid glitches
 * like short white screen or scroll reset on
 * language switch
 */
export const Route = createFileRoute('/profile/$customerId/$userId')({
    component: Outlet,
    async loader({ params }) {
        const response = await api.customerUser.publicSearch.request([
            {
                customerId: params.customerId,
                userId: params.userId,
            },
        ]);
        if (response.status !== 'ok') {
            return response;
        }
        const result = response.list[0];
        if (result) {
            const config = configStore.get();
            const languagesTranslated = config.state === 'initialized'
                ? config.languagesTranslated
                : [];
            return {
                status: 'ok',
                ...result,
                user: {
                    ...result.user,
                    languages: languagesTranslated.filter(({ iso }) => result.user.languages.includes(iso)),
                },
            };
        }
        return {
            status: 'not found',
        };
    },
});
//# sourceMappingURL=$customerId.$userId.js.map